<template>
  <div class="home">
    <section class="hero" ref="heroRef">
      <div class="overlay">
        <h1>ارسال سفته درب منزل</h1>
        <p>
          اگر امکان تهیه سفته رو ندارید و همه جا بسته س 
          و سفته الکتریکی هم قبول نمی کنن و دردسر های شبیه به این که حالا از کجا سفته پیدا کنم
           رو حل کردیم و از مرحله ی بعدی میگم سلام
          سفته خان هستم 
          میتونم بگم تو محدوده ی شما کجا ها سفته داره که میتونه بفروشه و با فروشنده مستقیما ارتباط بگیرید و باهم تعامل کنید
          البته فروشنده هایی که درخواست سفته دارند هم میتونن درخواست خودشون رو ثبت کنن و طی پکیج های متنوع ما رو سفارش بدن تا در عرض سه الی هفت روز کاری به هر نقطه ای از ایران براشون ارسال بشه
        </p>
        <div class="hero-buttons">
          <a @click="order()" class="primary-btn">
            فروشنده م
          </a>
          <a @click="getOrder()" class="outline-btn">
            سفته میخوام
          </a>
        </div>
      </div>
    </section>
    <section class="stats" ref="statsRef" v-if="false">
      <div class="overlay">
        
      </div>
    </section>
    <section class="projects" ref="projectsRef">
      <div class="overlay">
        <h2>نمونه پکیج ها</h2>
        <div class="grid-3">
          <div class="image-card" v-for="v in allPack" :key="v.id">
            <PackageShablone :data="v" @pay="payPack" :btnName="'خرید پکیج'"/>
          </div>
        </div>
      </div>
    </section>
    <section class="features" ref="featuresRef">
      <div class="overlay">
        <h2>با منم بهتون خوش میگذره</h2>
        <div class="grid-3">
          <div class="card">
            <h3>دسترسی سریع</h3>
            <p>
              با یه تماس به فروشنده وصل میشی
            </p>
          </div>
          <div class="card">
            <h3>سفارش آنلاین</h3>
            <p>
              واسه فروشنده ها پکیج ارسال میشه
            </p>
          </div>
          <div class="card">
            <h3>ارسال به سراسر کشور</h3>
            <p>از هر نقطه ای که هستی میتونی پکیج ها رو سفارش بدی پست میشه برات</p>
          </div>
          <div class="card">
            <h3>خدمت رسانی</h3>
            <p>خدمت رسانی در محدوده ی مورد نیاز و دردسترس شما</p>
          </div>
        </div>
      </div>
    </section>
    <section class="timeline" ref="timelineRef">
      <div class="overlay">
        <h2>فرآیند عضویت در فروشگاه</h2>
        <div class="timeline-item" v-for="(step,i) in process" :key="i">
          <div class="circle">{{ i+1 }}</div>
          <div class="content">
            <h3>{{ step.title }}</h3>
            <p>{{ step.desc }}</p>
          </div>
        </div>
      </div>
    </section>
    <section class="testimonials" ref="testimonialsRef">
      <div class="overlay">
        <h2>امکانات دیگر</h2>
        <div class="grid-3">
          <div class="card" v-for="review in reviews" :key="review.name">
              <strong>{{ review.name }}</strong>
            <p>"{{ review.text }}"</p>
          </div>
        </div>
      </div>
    </section>
    <section class="faq" ref="faqRef">
      <div class="overlay">
        <h2>اخبار مربوط</h2>
        <div v-for="(item,index) in faq" :key="index" class="faq-item">
          <h4 @click="toggleFaq(index)">
            {{ item.q }}
          </h4>
          <p v-if="item.open">{{ item.a }}</p>
        </div>
        <h2>همین حالا فروشندگی را شروع کنید</h2>
        <p>به جمع صدها فروشگاه فعال بپیوندید.</p>
        <RouterLink class="primary-btn large faq-item" :to="{path:'/login'}">شروع کنید</RouterLink>
      </div>
    </section>
    <section class="cta" ref="ctaRef">
      <div class="overlay">
        <div class="stats">
          <div class="stat" v-for="stat in stats" :key="stat.title">
            <h2>{{ stat.number }}</h2>
            <p>{{ stat.title }}</p>
          </div>
        </div>
      </div>
    </section>
    <footer class="footer">
      <div>© 2026 - پلتفرم سفارش سفته فیزیکی سفته خان</div>
    </footer>
  </div>
</template>

<script setup>
  import { reactive, ref, onMounted } from 'vue'
  import { BASE_URL } from '@/config';
  import { useUserStore } from '@/stores/user';
  import { useAlertStore } from '@/stores/alert';
  import { packagesList } from '@/composables/packagesList';
  import router from '@/router';
  import PackageShablone from '@/components/dashboard/bodys/factor/PackageShablone.vue';
  const allPack = packagesList();
  const alertStore = useAlertStore() 
  const user=useUserStore()
  const heroRef  = ref(null)
  const timelineRef = ref(null)
  const statsRef = ref(null)
  const featuresRef = ref(null)
  const projectsRef = ref(null)
  const testimonialsRef = ref(null)
  const faqRef = ref(null)
  const ctaRef = ref(null)
  const backgroundImageTop=ref(BASE_URL+'/assets/images/101.png')
  const backgroundImageBtm=ref(BASE_URL+'/assets/images/1001.jpg')
  const backgroundImageOne=ref(BASE_URL+'/assets/images/19.jpg')
  const backgroundImageTwo=ref(BASE_URL+'/assets/images/08.jpg')
  const backgroundImageThree=ref(BASE_URL+'/assets/images/07.jpg')
  const backgroundImageFour=ref(BASE_URL+'/assets/images/103.png')
  const backgroundImageFive=ref(BASE_URL+'/assets/images/1000.jpg')
  const backgroundImageSix=ref(BASE_URL+'/assets/images/105.png')
  
  const order = () => {
    if(user.isLoggedIn()){
      router.push({ path: '/add-product' })
    }else{
      user.loginNeeded()
      alertStore.msg='نیاز به ورود دارید'
      router.push({ path: '/login' })
    } 
  }
  const payPack = (val) =>{
    if(user.isLoggedIn()){
      router.push({ path: '/add-factor/'+val })
    }else{
      user.loginNeededFac(val)
      alertStore.msg='نیاز به ورود دارید'
      router.push({ path: '/login' })
    }
  } 
  const getOrder = () =>{
    if(user.isLoggedIn()){
      router.push({ path: '/dashboard' })
    }else{
      router.push({ path: '/show-public' })
    } 
  }
  const stats = ref([
    { number: '1200+', title: 'سفارش ثبت شده' },
    { number: '350+', title: 'فروشنده فعال' },
    { number: '98%', title: 'رضایت مشتریان' }
  ])
  const process = ref([
    { title: 'ثبت نام', desc: 'برای ارسال آگهی کافیست ابتدا با شماره ای که برای صحبت با مشتریان خود در نظر دارید را وارد کنید' },
    { title: 'ایجاد آگهی', desc: 'در قسمت مربوط به ثبت آگهی محدوده قابل دسترسی و آدرس خود به همراه تعداد و نوع سفته ها مشخص کنید' },
    { title: 'نمایش آگهی', desc: 'کاربرانی که قصد خرید سفته را دارند می توانند با دیدن آگهی ها شما را مخاطب قرار دهند ' },
    { title: 'فروش بیشتر', desc: 'ارتباط مستقیم فروشنده و خریدار منجر به فروش بیشتر می شود' }
  ])
  const reviews = ref([
    { name: 'چت درون سیستم', text: 'امکان چت برای مخاطبان وجود دارد' },
    { name: 'ارسال رایگان پکیج', text: 'ارسال به تمام نقاط کشور' },
    { name: 'پشتیبانی 24 ساعته', text: 'همه ساعته در پاسخگویی حاضریم' },
    { name: 'فروش مستقیم پکیج', text: ' با شماره گیری 09336160295 می توانید مستقیما خرید کنید' }
  ])
  const faq = reactive([
    { q: 
      'سفته الکتریکی'
      , a: 'به گزارش روابط عمومی بانک ملی ایران، در گام نخست ارتقای فرآیند صدور سفته و برات به صورت الکترونیک، دسترسی مردم و کسب و کارها به این اوراق تجاری تسهیل می شود و مشتریان در صورت نیاز می توانند برات و سفته را به صورت الکترونیکی، غیرحضوری و 24 ساعته خریداری کنند بنابراین سفته و برات الکترونیکی بر اساس محل مصرف، موضوعیت خواهد داشت.به عبارتی، در اعطای تسهیلات غیرحضوری، در صورتی که تضمین سفته باشد، در مرحله توثیق وثایق فرآیند تسهیلات، سرویس فروش سفته از طرف وزارت اقتصاد تولید خواهد شد. سپس هزینه مربوطه اخذ و امضای الکترونیکی مشتری به فرآیند اضافه می شود که همه این مراحل از طریق سرویس های وزارت اقتصاد و بانک به صورت سیستمی انجام خواهند شد.کاربرد دیگر، در تامین مالی زنجیره ای است. به عبارتی، در پلتفرم زنجیره تامین که خریدار و فروشنده در یک فضای الکترونیکی معامله می کنند، می توانند برای پرداخت خود برات الکترونیک را در نظر بگیرند که در این رویکرد نیز فرآیند خرید برات الکترونیک مشابه سفته الکترونیک انجام خواهد شد.بر این اساس، زیرساخت سفته و برات الکترونیک با مشارکت و ورود سایر بانک ها به این عرصه محقق شده و همکاری سایر شبکه بانکی را می طلبد تا ضمن ورود بانک، این اوراق در تعامل مشترک با وزارت اقتصاد در اختیار مشتری قرار گیرند.همچنین بانک ملی ایران آمادگی را دارد به منظور تمرکز بر خلق راه حل های بانکی و مالی، زیرساخت سرویس های سفته و برات الکترونیکی و تجربیات خود در زمینه را در اختیار سایر بانک ها و نظام بانکی کشور قرار دهد.', open: false },
    { q: 
      'تغییرات اخیر',
       a: 'به گزارش روابط عمومی بانک ملی ایران، در راستای اجرای اصلاحیه ماده 45 قانون مالیات‌های مستقیم مصوب 31 تیر ماه 1394مجلس شورای اسلامی، از ابتدای سال جاری حق تمبر انواع سفته‌ و برات از سه در هزار به نیم در هزار کاهش یافته است که با هدف جلوگیری از ابطال و امحای مقادیر زیادی از سفته‌ها و بروات‌ با ارزش اسمی قبل از تاریخ اول فروردین ماه 1395، ممهور نمودن میزان کاربری جدید بر روی اسناد فوق طبق نامه معاونت نظارت‌ مالی و خزانه‌داری کل کشور وزارت امور اقتصادی و دارایی مجاز و دارای اعتبار است.بر این اساس پس از اتمام موجودی سفته و بروات‌ قبلی، چاپ این اسناد بهادار با میزان کاربری جدید انجام خواهد شد.به گزارش روابط عمومی بانک ملی ایران ،این سفته  ها توسط وزارت امور اقتصادی و دارایی تهیه شده است و بانک ملی ایران به عنوان بانک عامل، از فردا عرضه آن ها را به موازات سفته های قبلی در شعب آغاز خواهد کرد.سفته های جدید نسبت به نمونه قبلی از نظر ظاهری با تغییراتی همراه بوده است. گفتنی است سفته های قدیمی همچنان دارای اعتبار می باشد.', open: false },
    { q:
       'بازخورد سفته الکتریکی', 
       a:
        'خزانه دار کل کشور با ابراز رضایت کامل خود از اقدام مشترک با بانک ملی ایران در صدور سفته و برات الکترونیک گفت: سالیان طولانی مردم باید برای خرید سفته خود به دکه محله شان مراجعه می کردند اما امروز این خدمت با هوشمندی بانک ملی ایران به سادگی و کاملا به صورت الکترونیکی و غیرحضوری انجام می شود.', open: false },
    {
      q:'نظر بانک ملی',
      a:'بانک ملی ایران جزئیات «خرید سفته و برات الکترونیک» را که به عنوان یکی از بنیادی ترین تحول دیجیتالی شدن نظام بانکی و تحقق رویکرد بانکداری الکترونیک کلید خورده است، تشریح کرد.',
      open:false
    },
    // {
    //   q:'',
    //   a:'',
    //   open:false
    // }
  ])
  function toggleFaq(index){
    faq[index].open = !faq[index].open
  }
  function useLazyBg(elRef, imageUrl) {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.backgroundImage = `url(${imageUrl})`
          observer.unobserve(entry.target)
        }
      })
    }, { rootMargin: '150px' })
    onMounted(() => {
      if (elRef.value) observer.observe(elRef.value)
    })
  }
  useLazyBg(heroRef, backgroundImageTop.value)
  useLazyBg(timelineRef, backgroundImageBtm.value)
  useLazyBg(statsRef, backgroundImageOne.value)
  useLazyBg(featuresRef, backgroundImageTwo.value)
  useLazyBg(projectsRef, backgroundImageThree.value)
  useLazyBg(testimonialsRef, backgroundImageFour.value)
  useLazyBg(faqRef, backgroundImageFive.value)
  useLazyBg(ctaRef, backgroundImageSix.value)
</script>

<style scoped>
  
  .home{
    gap: 0;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    overflow: hidden;
  }

  .hero {
    text-align:center;
  }
  .hero p {
    width: 70%;
    margin: 25px auto;
    word-break: break-word;
  }
  .hero-buttons{
    justify-content: center;
    flex-direction: row-reverse;
    align-items: stretch;
    display: flex;
  }
  .hero a ,.cta a{
    width: 100%;
    margin: 5px;
    text-decoration: none;
  }
  .home section,.home footer { 
    width: 100%;
    box-sizing: border-box;
    background-size: cover;
    background-position: center;
  }
  .home section:hover {
    transform:matrix(1.04, 0, 0, 1.04, 0, -4);
    transition: transform .8s cubic-bezier(0.11, 0.83, 1, 0.56);
  }
  .overlay {
    height: 100%;
    text-align: center;
    background: rgba(0,0,0,0.6);
    padding: 25px;
    margin: 10px;
    color: white;
    border-radius: 20px;
    box-sizing: border-box;
  }
  .stats {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
  .stat h2 { font-size:40px; color:#6366f1 }
  .grid-3 {
    display:grid;
    grid-template-columns:repeat(auto-fit,minmax(250px,1fr));
    gap:30px;
    margin-top:40px;
  }
  .card {
    background:#f9fafb;
    padding:25px;
    color: black;
    border-radius:16px;
  }
  .hero,.stats,.features,.projects,.testimonials,.faq,.cta,.timeline{
      background-size:cover;
      background-position:center;
      direction: rtl;
  }
  .timelineGroup{
    background: #ffffffa3;
    border-radius: 30px;
    padding: 10px;
  }
  .timeline-item {
    display:flex;
    align-items:center;
    margin:30px auto;
    max-width:600px;
    text-align:right;
  }
  .circle {
    width:40px;
    height:40px;
    border-radius:50%;
    background:#6366f1;
    color:white;
    display:flex;
    align-items:center;
    justify-content:center;
    margin-left:15px;
  }
  .faq-item {
    max-width:600px;
    margin:20px auto;
    text-align:right;
    cursor:pointer;
  }
  .faq-item h4 { background:#eee; color: black;padding:15px; border-radius:8px }
  .cta { color:white; }
  .large { 
    text-align: center;
    padding: 12px 0 !important;
    display: block;
    font-size: 18px;
  }
  .footer {
    background:#111;
    color:white;
    padding:30px;
    display:flex;
    justify-content:space-between;
    flex-wrap:wrap;
  }
  .primary-btn {
    background:#6366f1;
    color:white;
    padding:12px 24px;
    border:none;
    text-decoration: none;
    border-radius:10px;
    cursor:pointer;
  }
  .outline-btn {
    background:transparent;
    border:2px solid white;
    text-decoration: none;
    color:white;
    padding:12px 24px;
    border-radius:10px;
    margin-left:10px;
    cursor:pointer;
  }
</style>